const RelatedProducts = {
	init: function () {
		const carousels = document.querySelectorAll('[data-related-products-carousel]');

		if (!carousels.length) return;

		this.swiperHandler(carousels);
	},

	swiperHandler: function (carousels) {
		carousels.forEach((carousel) => {
			const container = carousel.closest('[data-related-products]');
			const nextButton = container.querySelector('[data-related-products-next]');
			const previousButton = container.querySelector('[data-related-products-previous]');

			const swiper = new Swiper(carousel, {
				loop: false,
				slidesPerView: 2,
				spaceBetween: 24,
				allowTouchMove: false,
				navigation: {
					nextEl: nextButton,
					prevEl: previousButton,
				},
			});
		});
	},
};

export default RelatedProducts;
RelatedProducts.init();
